import { styled } from '@mui/material/styles';

export const CorrectionDiv = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(9.5),
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(3.5),
  },
}));
